<template>
  <div class="d-flex">
    <!-- SinalDeposit Option (exato, maior, menor) -->
    <v-select
      v-model="selectSinalAward"
      :items="items"
      :label="$t('byAward')"
      @change="setSinalAward"
      prepend-icon="mdi-cash-marker"
      item-text="text"
      item-value="option"
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
    <!-- Sinal Valor -->
    <v-text-field
      v-model="valorAward"
      class="ml-2"
      label="Outlined"
      :prefix="$t('labelCurrency')"
      :placeholder="$t('value')"
      solo-inverted
      dense
      hide-details
      @change="setSinalAward"
      type="number"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-sinalDeposit",
  data: () => ({
    selectSinalAward: null,
    valorAward: null,
  }),
  computed: {
    items() {
      return [
        { text: this.$t("exactAward"), option: "exatamente" },
        { text: this.$t("awardGreaterThan"), option: "maior" },
        { text: this.$t("awardLessThan"), option: "menor" },
      ];
    },
  },
  mounted() {
    // Recupera o último valorAward informado pelo o usuário
    // e deixa o selectSinalAward selecionado com o mesmo.
    var option = this.$store.state.filters.sinalAward.option;
    var selectSinalAward = this.items.filter(
      (element) => element.option == option
    );
    this.selectSinalAward = selectSinalAward[0];
  },
  methods: {
    setSinalAward() {
      var option = this.selectSinalAward;
      var valor = this.valorAward;
      // Só enviar para o vuex se os dois estiverem preenchidos:
      if (option != null && valor != null) {
        this.$store.commit("setSinalAward", { option, valor });
      }
    },
  },
};
</script>
